import { render, staticRenderFns } from "./brandExclusive.vue?vue&type=template&id=28ebdebd&scoped=true&"
import script from "./brandExclusive.vue?vue&type=script&lang=js&"
export * from "./brandExclusive.vue?vue&type=script&lang=js&"
import style0 from "./brandExclusive.vue?vue&type=style&index=0&id=28ebdebd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ebdebd",
  null
  
)

export default component.exports